import api, { queryClient } from "@app/config/api/api";
import { notifications } from "@lib/notification/notification";

export const labelListOptions = (teamId?: string) =>
  teamId
    ? api.queryOptions("get", "/labels/", { params: { query: { team_id: teamId } } })
    : api.queryOptions("get", "/labels/");

export const useLabelList = (teamId?: string) =>
  teamId
    ? api.useQuery("get", "/labels/", { params: { query: { team_id: teamId } } })
    : api.useQuery("get", "/labels/");

export const invalidateLabelList = async () => {
  // Prefix key so team-scoped lists (["get", "/labels/", { params: ... }]) are invalidated too.
  return queryClient.invalidateQueries({ queryKey: ["get", "/labels/"] });
};

export const usePatchLabel = () =>
  api.useMutation("patch", "/labels/{label_id}", {
    onSuccess: async () => {
      await invalidateLabelList();
      notifications.success("Label updated.");
    },
    onError: error => notifications.error("Failed to update label", error.message)
  });

export const useDeleteLabel = () =>
  api.useMutation("delete", "/labels/{label_id}", {
    onSuccess: async () => {
      await invalidateLabelList();
      notifications.success("Label deleted.");
    },
    onError: error => notifications.error("Failed to delete label", error.message)
  });
